import React, { useContext } from "react";
import { ReservationsContext } from "../../context/ReservationsContext";

const ReservationTableFilters = () => {
  const {
    filter,
    setCurrentFilter,
    reservationFilters,
  } = useContext(ReservationsContext);

  const renderFilters = () => {
    if(Array.isArray(reservationFilters)) {
      return reservationFilters.map(currentFilter => {
        const isSelected = currentFilter.value === filter;

        if(isSelected) {
          return (
            <button 
              key={currentFilter.value}
              className="btn btn-sm btn-focus-disabled btn-primary"
              onClick={() => setCurrentFilter(currentFilter.value)}
            >
              {currentFilter.name}
            </button>
          )
        } else {
          return (
            <button 
              key={currentFilter.value}
              className="btn btn-sm btn-focus-disabled btn-outline-primary"
              onClick={() => setCurrentFilter(currentFilter.value)}
            >
              {currentFilter.name}
            </button>
          )
        }
      });
    }
  }

  return (
    <div className="btn-group d-block mb-3 w-100">
      {renderFilters()}
    </div>
  );
};

export default ReservationTableFilters;
